import * as React from 'react';
import RangePicker from '@/form-component/range-picker';
import { prefixCls } from '@/constants';
import { Form } from 'antd';

export default function ActivityRangePicker(props) {
  // 预热器 专场期 高潮期 返场期
  const { step0, step1, step2, step3, curStep = 1, value, onChange, className, placeholder } = props;
  const [state, setState] = React.useState({
    limitLeft: null,
    limitRight: null,
  });

  React.useEffect(() => {
    const stepsArr = [step0, step1, step2, step3];

    var i, len;
    const leftSteps = stepsArr.slice(0, curStep);
    let limitLeft = null;
    // 从右往左找到第一个
    for (i = leftSteps.length - 1; i >= 0; i--) {
      if (leftSteps[i] && leftSteps[i][1]) {
        limitLeft = leftSteps[i][1];
        break;
      }
    }

    const rightSteps = stepsArr.slice(curStep + 1);
    let limitRight = null;
    // 从左往右找到第一个
    for (i = 0, len = rightSteps.length; i < len; i++) {
      if (rightSteps[i] && rightSteps[i][0]) {
        limitRight = rightSteps[i][0];
        break;
      }
    }

    setState({
      limitLeft,
      limitRight,
    });
  }, [curStep, step0, step1, step2, step3]);

  function disabledDate(current) {
    if (!current) return current;

    if (state.limitLeft && state.limitRight) {
      return (
        current.startOf('day') < state.limitLeft.endOf('day') || current.endOf('day') > state.limitRight.startOf('day')
      );
    }

    if (state.limitLeft) {
      return current.startOf('day') < state.limitLeft.endOf('day');
    }

    if (state.limitRight) {
      return current.endOf('day') > state.limitRight.startOf('day');
    }

    return false;
  }

  return (
    <RangePicker
      value={value}
      onChange={onChange}
      disabledDate={disabledDate}
      className={className}
      placeholder={placeholder}
    />
  );
}

function acitivtyRangePickerShouldUpdate(prevValues, curValues) {
  return (
    prevValues.preTime !== curValues.preTime ||
    prevValues.specialTime !== curValues.specialTime ||
    prevValues.highTime !== curValues.highTime ||
    prevValues.backTime !== curValues.backTime
  );
}

const TIME_NAMES = ['preTime', 'specialTime', 'highTime', 'backTime'];

function createTimeFn({ name, label }) {
  return ({ getFieldsValue }) => {
    if (TIME_NAMES.indexOf(name) === -1) {
      throw new Error('name不在列表 ' + TIME_NAMES.join(',') + ' 中');
    }

    const { preTime: step0, specialTime: step1, highTime: step2, backTime: step3 } = getFieldsValue(TIME_NAMES) || {};

    return (
      <Form.Item label={label} name={name}>
        <ActivityRangePicker
          curStep={TIME_NAMES.indexOf(name)}
          step0={step0}
          step1={step1}
          step2={step2}
          step3={step3}
          className={`${prefixCls}-picker-full-size`}
          placeholder={['开始日期', '结束日期']}
        />
      </Form.Item>
    );
  };
}

export { acitivtyRangePickerShouldUpdate, createTimeFn };
